import instance from "../interceptors/AxiosInterceptor";

const BASE_URL = "/api/dms";
const dmsService = {

    getStatistics: async () => {
        try {
            const response = await instance.get(`${BASE_URL}/statistics`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getSettings: async () => {
        try {
            const response = await instance.get(`${BASE_URL}/settings`, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    updateSettings: async (body) => {
        try {
            const response = await instance.put(`${BASE_URL}/settings`, body, {
                withCredentials: true
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    },

}

export default dmsService;